import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../apiClient';

// Local midnight of the most recent Friday (today, if today is Friday). The API shows the popup only
// if the user hasn't dismissed it since then, so it appears once per week on the first visit on or
// after a Friday.
export function lastFridayStart(now = new Date()) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  d.setDate(d.getDate() - ((d.getDay() + 2) % 7));
  return d;
}

const CATEGORY_LABEL = {
  'New feature': 'New',
  'Bug or annoyance': 'Fixed',
  'Data or report': 'Data',
  General: 'Update',
};
const CATEGORY_BADGE = {
  'New feature': 'badge-green',
  'Bug or annoyance': 'badge-blue',
  'Data or report': 'badge-yellow',
};

export default function WhatsNewPopup() {
  const [items, setItems] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    let cancelled = false;
    apiFetch(`/suggestions/whats-new?weekStart=${encodeURIComponent(lastFridayStart().toISOString())}`)
      .then((r) => { if (!cancelled) setItems(r?.items ?? []); })
      .catch(() => {}); // a missing popup is never worth an error banner
    return () => { cancelled = true; };
  }, []);

  if (items.length === 0) return null;

  // Only "Got it" records a dismissal. Closing any other way just hides it until the next load.
  const later = () => setItems([]);
  const dismiss = () => {
    setItems([]);
    apiFetch('/suggestions/whats-new/seen', { method: 'POST' }).catch(() => {});
  };
  const goToBacklog = () => { setItems([]); navigate('/suggestions?tab=whatsnew'); };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="What's new in Pulse" onClick={later}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">What's new in Pulse</span>
          <button className="modal-close" onClick={later} aria-label="Close">×</button>
        </div>
        <div className="modal-body">
          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 12 }}>
            {items.map((i) => (
              <li key={i.id} style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                <span className={`badge ${CATEGORY_BADGE[i.category] || 'badge-gray'}`}>
                  {CATEGORY_LABEL[i.category] || 'Update'}
                </span>
                <span>
                  {i.area && <strong>{i.area}: </strong>}
                  {i.releaseNote}
                  {i.linkUrl && (
                    <>
                      {' '}
                      <a href={i.linkUrl} target="_blank" rel="noopener noreferrer">Details</a>
                    </>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={later}>Show me later</button>
          <button className="btn btn-outline" onClick={goToBacklog}>Go to backlog</button>
          <button className="btn btn-primary" onClick={dismiss}>Got it</button>
        </div>
      </div>
    </div>
  );
}
